import {
    TYPE_TEXT_SHORT,
    TYPE_TEXT_LONG,
    TYPE_BOOLEAN,
    TYPE_NUMBER,
    TYPE_DATETIME,
    TYPE_LOCATION,
    TYPE_REFERENCE,
    CONTENT_TYPE_ASSET,
} from "../services/constants"

export const fieldTypesMixin = {
    methods: {
        isTextShortField(field) {
            return field.type === TYPE_TEXT_SHORT
        },
        isTextLongField(field) {
            return field.type === TYPE_TEXT_LONG
        },
        isBooleanField(field) {
            return field.type === TYPE_BOOLEAN
        },
        isNumberField(field) {
            return field.type === TYPE_NUMBER
        },
        isDatetimeField(field) {
            return field.type === TYPE_DATETIME
        },
        isLocationField(field) {
            return field.type === TYPE_LOCATION
        },
        isReferenceField(field) {
            return field.type === TYPE_REFERENCE && field.referenceType
        },
        isMultipleReferenceField(field) {
            return this.isReferenceField(field) && field.allowsMultiple
        },
        isMediaReferenceField(field) {
            return field.referenceType && field.referenceType === CONTENT_TYPE_ASSET
        },
    }
}